import { Button, Col, Row, Typography, Tabs } from "antd"
import { useNavigate } from "react-router-dom"
import { useContainerInjection } from "../../hooks/useContainerInjection"
import { SurveysViewModel } from "./SurveysViewModel"
import { observer } from "mobx-react"
import { useTranslation } from "react-i18next"
import { Card } from "../../styledComponents/CustomCard/Card"
import SurveysTable from "./components/SurveysTable"
import SectionsTable from "./components/SectionsTable"
import { RoutePaths } from "../../navigation/RoutePaths.enum"
import SearchFilterField from "../../components/SearchFilterField/SearchFilterField"
import { Survey } from "../../../domain/entities/Survey"
import { SurveySection } from "../../../domain/entities/SurveySection"

const { Title } = Typography

const SurveysView = () => {
	const { t } = useTranslation("surveys")
	const viewModel = useContainerInjection<SurveysViewModel>("SurveysViewModel")
	const navigate = useNavigate()

	const filterFunction = (value: Partial<Survey>, searchInput: string | undefined) => {
		return searchInput && isNaN(parseInt(searchInput))
			? searchInput
				? !(value?.title?.toLowerCase().indexOf(searchInput.toLowerCase()) === -1)
				: true
			: searchInput
			? !(value?.id?.toString().indexOf(searchInput) === -1)
			: true
	}

	const filterSurveySectionsFunction = (value: Partial<SurveySection>, searchInput: string | undefined) => {
		return searchInput && isNaN(parseInt(searchInput))
			? searchInput
				? !(value?.name?.toLowerCase().indexOf(searchInput.toLowerCase()) === -1)
				: true
			: searchInput
			? !(value?.id?.toString().indexOf(searchInput) === -1)
			: true
	}

	const items = [
		{
			key: "surveys",
			label: t("surveys"),
			children: (
				<>
					<SearchFilterField<Survey>
						value={viewModel.searchValue}
						placeholder={t("searchBar").toString()}
						searchData={viewModel.surveys}
						filterFunction={filterFunction}
						onChange={value => {
							viewModel.setSearchedSurveys(value as Survey[])
						}}
						onChangeText={value => viewModel.setSearchValue(value)}
						style={{ marginBottom: "10px" }}
					/>
					<div className="tabled">
						<Row gutter={[24, 0]}>
							<Col xs="24" xl={24}>
								<Card
									bordered={false}
									className="criclebox tablespace mb-24"
									title={
										<div style={{ display: "flex", alignItems: "center" }}>
											<Title style={{ marginTop: 8 }} level={4}>
												{t("title")}
											</Title>
											<Button
												style={{ marginLeft: "1.5vw" }}
												type="primary"
												onClick={() => navigate(RoutePaths.SURVEYS_NEW)}
											>
												{t("addNew")}
											</Button>
										</div>
									}
								>
									<SurveysTable data={viewModel.searchedSurveys} />
								</Card>
							</Col>
						</Row>
					</div>
				</>
			)
		},
		{
			key: "sections",
			label: t("sections"),
			children: (
				<>
					<SearchFilterField<SurveySection>
						value={viewModel.searchValue}
						placeholder={t("searchSectionsBar").toString()}
						searchData={viewModel.surveySections}
						filterFunction={filterSurveySectionsFunction}
						onChange={value => {
							viewModel.setSearchedSurveySections(value as SurveySection[])
						}}
						onChangeText={value => viewModel.setSearchValue(value)}
						style={{ marginBottom: "10px" }}
					/>
					<div className="tabled">
						<Row gutter={[24, 0]}>
							<Col xs="24" xl={24}>
								<Card
									bordered={false}
									className="criclebox tablespace mb-24"
									title={
										<div style={{ display: "flex", alignItems: "center" }}>
											<Title style={{ marginTop: 8 }} level={4}>
												{t("sectionsTitle")}
											</Title>
											<Button
												style={{ marginLeft: "1.5vw" }}
												type="primary"
												onClick={() => navigate(RoutePaths.SURVEY_SECTIONS_NEW)}
											>
												{t("addNewSection")}
											</Button>
										</div>
									}
								>
									<SectionsTable data={viewModel.searchedSurveySections} />
								</Card>
							</Col>
						</Row>
					</div>
				</>
			)
		}
	]

	return (
		<>
			<Tabs defaultActiveKey="surveys" items={items} />
		</>
	)
}

export default observer(SurveysView)
